import ApiConfig from '../../config/api'

import BaseListModel from './BaseListModel'

export default class ShelfModel extends BaseListModel {
  apiUrl = ApiConfig.api.shop.shelf_list
}

export const shelfStore = new ShelfModel()
